import { useMemo } from "react";
import useResponsiveValues from "@/components/editor/hooks/useResponsiveValues";
import { ImageProps } from "./ImageSettings";
import useVariableValues from "../../hooks/useVariableValues";

const PROPS: (keyof ImageProps)[] = ["src", "objectFit", "objectPosition", "modal", "href", "target"];

const useNormalizeImageSettings = (props: ImageProps) => {
  const responsive = useResponsiveValues();
  const vv = useVariableValues(true);

  const draft = useMemo(() => {
    const draft: ImageProps = {};

    PROPS.forEach((prop) => {
      const value = responsive.getValue(props[prop]);

      if (prop === "src") {
        draft[prop] = vv.getValue(value ?? "");
      } else if (props[prop]) {
        draft[prop] = value;
      }
    });

    return draft;
  }, [props, responsive, vv]);
  return draft;
};

export default useNormalizeImageSettings;
